import { createReducer } from 'redux-act';
import {
  setData,
  failGetData,
  successGetData,
  getPromotion,
  getCourse,
  putOrder,
  putItemOrder,
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  checkUser,
  failCheckUser,
  successCheckUser,
} from '../actions/order';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  isFetching: false,
  buyType: '0',
  course: undefined,
  promotion: {},
  courseId: undefined,
  paymentId: undefined,
  price: 0,
  data: {},
  creditToken: undefined,
  maskedCardNumber: undefined,
  cardLimitDate: undefined,
  authcode: undefined,
  error: undefined,

  customer: undefined,
};

const data = createReducer(
  {
    [setData]: (state, payload) => Object.assign({}, state, payload),
    [failGetData]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successGetData]: (state, payload) =>
      Object.assign({}, state, payload, {
        isFetching: false,
        error: undefined,
      }),
    [putOrder]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [putItemOrder]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [getPromotion]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [getCourse]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [checkEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        data: payload,
        authcode: undefined,
        error: undefined,
      }),
    [failCheckEmail]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successCheckEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        authcode: payload.authcode,
        jwt: payload.jwt,
        error: undefined,
      }),
    [checkUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        customer: undefined,
        error: undefined,
      }),
    [failCheckUser]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successCheckUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        customer: payload.data,
        buyFlag: payload.buyFlag,
        matchFlag: payload.matchFlag,
        error: undefined,
      }),
  },
  initial
);

export default data;



// WEBPACK FOOTER //
// ./src/reducers/order.js